import { Activities } from '@/components/activities/Activities/Activities';
import { useInfiniteActivities } from '@/models/article';

export const ArticleActivities = ({ articleId }: { articleId: string }) => {
  const { data, isLoading, isError, fetchNextPage } = useInfiniteActivities({
    articleId,
  });

  const activities = data?.pages.flatMap((page) => page.activities) ?? [];

  return (
    <Activities
      activities={activities}
      isLoading={isLoading}
      isError={isError}
      isArticle
      loadNextPage={() => {
        fetchNextPage();
      }}
    />
  );
};
